/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Caption_Editing_Aria_LabelInputs */

const en_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption editing tools`)
};

const fr_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils d'édition de sous-titres`)
};

const de_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenbearbeitungswerkzeuge`)
};

const it_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di modifica delle didascalie`)
};

const ru_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`инструменты редактирования субтитров`)
};

const es_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de edición de subtítulos`)
};

const zh_cn2_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕编辑工具`)
};

const ja_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション編集ツール`)
};

const hi_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन संपादन उपकरण`)
};

const pt_pt2_toolbar_secondary_caption_editing_aria_label = /** @type {(inputs: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de edição de legendas`)
};

/**
* | output |
* | --- |
* | "Caption editing tools" |
*
* @param {Toolbar_Secondary_Caption_Editing_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_caption_editing_aria_label = /** @type {((inputs?: Toolbar_Secondary_Caption_Editing_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Caption_Editing_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "de") return de_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "it") return it_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "ru") return ru_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "es") return es_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "ja") return ja_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "hi") return hi_toolbar_secondary_caption_editing_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_caption_editing_aria_label(inputs)
	return en_toolbar_secondary_caption_editing_aria_label(inputs)
});